import clsx from "clsx";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useUser } from "../store";
import { toSlug } from "common";
import GlobalSearch from "./GlobalSearch";
import AlertsBell from "./AlertsBell";
import "./Nav.scss";

export default function Nav() {
  const [burgerClicked, setBurgerClicked] = useState(false);
  const { user, authenticated, logout, group } = useUser();

  return (
    <nav className="navbar is-link has-shadow is-unselectable app-navbar" aria-label="Main navigation">
      <div className="navbar-brand">
        <Link to={group ? `/${toSlug(group)}` : "#"} className="navbar-item app-navbar-brand">
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/aging-report-mark.svg`}
            className="app-navbar-logo"
          />
          <span>{process.env.REACT_APP_APP_NAME}</span>
        </Link>
        <button
          type="button"
          aria-label={burgerClicked ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={burgerClicked}
          onClick={() => setBurgerClicked(!burgerClicked)}
          className={clsx("navbar-burger burger app-navbar-burger", {
            "is-active": burgerClicked,
          })}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      {authenticated && (
        <div
          className={clsx("navbar-menu app-navbar-menu", { "is-active": burgerClicked })}
          onClick={() => setBurgerClicked(false)}
        >
          <div className="navbar-start">
            <div className="navbar-item">
              <GlobalSearch onNavigate={() => setBurgerClicked(false)} />
            </div>
          </div>

          <div className="navbar-end">
            <div className="navbar-item">
              <AlertsBell onNavigate={() => setBurgerClicked(false)} />
            </div>
            <div className="navbar-item has-dropdown is-hoverable">
              <button type="button" className="navbar-item navbar-link has-pointer app-navbar-account">
                <span className="app-navbar-avatar" aria-hidden="true">
                  {user?.username?.charAt(0)?.toUpperCase()}
                </span>
                {user?.username}
              </button>
              <div className="navbar-dropdown is-boxed is-right">
                {user.type === "Admin" && (
                  <div>
                    <Link to="users" className="navbar-item app-navbar-dropdown-item">
                      <i className="fa-solid fa-users" aria-hidden="true" />
                      Users
                    </Link>
                    <Link to="daily-report-preview" className="navbar-item app-navbar-dropdown-item">
                      <i className="fa-solid fa-envelope-open-text" aria-hidden="true" />
                      Daily Report Preview
                    </Link>
                    <hr className="dropdown-divider" />
                  </div>
                )}
                <button
                  type="button"
                  className="navbar-item logout-link has-pointer app-navbar-dropdown-item app-navbar-logout"
                  onClick={logout}
                >
                  <i className="fa-solid fa-arrow-right-from-bracket" aria-hidden="true" />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
